import { ExecutionStatus } from './ExecutionConstants';

const DEPLOYMENT_RESULTS_TEXT = [
    'All Faro deployment(s) succeeded',
    'One or more Faro deployments failed',
    'One or more Faro deployments failed'
];
const TEST_RESULTS_TEXT = [
    'all tests passed',
    'one or more tests failed',
    'all tests failed'
];

class ExecutionStateParser {
    parseState(item: any) {
        let description;
        let status: ExecutionStatus = null;

        if (item.Errors && item.Errors.length) {
            description = 'This workflow execution has errors';
            status = ExecutionStatus.Failed;
        } else if (item.TimeStamp.includes('FAILED')) {
            description = 'This workflow execution has failed';
            status = ExecutionStatus.Failed;
        } else if (item.Cancelled !== undefined && item.Cancelled && item.TimeStamp.startsWith('RUNNING')) {
            description = 'This workflow execution was cancelled and is currently ending';
            status = ExecutionStatus.Cancelled;
        } else if (item.TimeStamp.startsWith('DEPLOY/TEST SCHEDULED') || item.TimeStamp.startsWith('TEARDOWN SCHEDULED')) {
            description = `This workflow is scheduled to be executed on ${item.ScheduledTime}`;
            status = ExecutionStatus.Scheduled;
        } else if (item.TimeStamp.startsWith('SCHEDULED')) {
            description = 'The scheduled execution of this workflow was cancelled';
            status = ExecutionStatus.Cancelled;
        } else if (item.TimeStamp.endsWith('WAITING')) {
            description = 'This workflow is waiting to be triggered';
            status = ExecutionStatus.Ready;
        } else if (item.TimeStamp.startsWith('WAITING')) {
            description = 'This pending execution was cancelled';
            status = ExecutionStatus.Cancelled;
        } else if (item.TimeStamp.startsWith('RUNNING')) {
            description = 'This workflow execution is currently running.';
            status = ExecutionStatus.InProgress;
        } else if (item.TimeStamp.startsWith('AWAITING APPROVALS')) {
            description = 'One or more people still need to approve this workflow execution before it can start.';
            status = ExecutionStatus.AwaitingApprovals;
        } else if (item.TimeStamp.startsWith('INITIALIZING')) {
            description = 'This workflow execution is preparing to run.';
            status = ExecutionStatus.InProgress;
        } else if (item.DeploymentScore !== -1 || item.TestScore !== -1) {
            description = `${DEPLOYMENT_RESULTS_TEXT[item.DeploymentScore]}${item.TestScore !== -1 ? ` and ${TEST_RESULTS_TEXT[item.TestScore]} ` : ''}.`;
            if (item.DeploymentScore > 0 || item.TestScore === 2) {
                status = ExecutionStatus.Failed;
            } else if (item.TestScore === 1) {
                status = ExecutionStatus.PassedWithWarnings;
            } else {
                status = ExecutionStatus.Passed;
            }
        } else {
            description = 'This workflow execution is currently running.';
            status = ExecutionStatus.InProgress;
        }
        return { description, status };
    }
}

export default ExecutionStateParser;